module.exports = __webpack_public_path__ + "static/media/bettery_hand.592b83f6.jpg";